/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'hsm-group-list-controller';
const prefix = `${moduleName}.${componentName}`;

export const actionBtnOpenWindowForClientCertDownload = `${prefix}.actionBtnOpenWindowForClientCertDownload`;
export const headerLabel = `${prefix}.headerLabel`;

export const ENGLISH = {
    [actionBtnOpenWindowForClientCertDownload]: 'Open window for client certificate download',
    [headerLabel]: 'HSM Groups',
};
